angular
  .module('ManagerControllers', [])

  //config for /supports
  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider

        .when('/m/students', {
          templateUrl: '/ng1/www/modules/manager/students/html/students.html',
          controller: 'ManagerStudentsCtrl'
        })

        .when('/m/spheres', {
          templateUrl: '/ng1/www/modules/teacher/spheres/html/home.html',
          controller: 'TeacherSpheresHomeCtrl'
        })

        .when('/m/institutions', {
          templateUrl: '/ng1/www/modules/manager/institutions/html/home.html',
          controller: 'ManagerTeachersCtrl'
        })

        .when('/m/teachers', {
          templateUrl: '/ng1/www/modules/manager/teachers/html/teachers.html',
          controller: 'ManagerTeachersCtrl'
        })

        .when('/m/licences', {
          templateUrl: '/ng1/www/modules/manager/licences/html/licences.html',
          controller: 'ManagerTeachersCtrl'
        });
    }
  ]);
